import { IScene } from './IScene';

import { SceneBase } from 'app/Scene/SceneBase';
export class SpaceScene extends SceneBase {


    
   
}


// WEBPACK FOOTER //
// D:/xamppabeel/htdocs/Angular2Projects/CanvasSVG/src/app/Scene/SpaceScene.ts